import {all, call} from 'redux-saga/effects';
import {getStatistics} from './fetchStatistics';
import {onExportReport} from './exportReport';

export default function* dashboardSaga() {
    yield all([
        call(getStatistics),
        call(onExportReport)
    ]);
}